import type { Column } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from '../../ui/button';
import { cn } from '../../ui/utils';
import { tt } from './messages';

export function SortableHeader<T>(props: {
  column: Column<T, unknown>;
  children: ReactNode;
  align?: 'start' | 'end';
}): ReactNode {
  const sorted = props.column.getIsSorted();
  const Icon = sorted === 'asc' ? ArrowUp : sorted === 'desc' ? ArrowDown : ArrowUpDown;
  const label = typeof props.children === 'string' ? props.children : props.column.id;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={cn('-mx-2 h-8', props.align === 'end' && 'ml-auto flex-row-reverse')}
      aria-label={tt('sort.label', { column: label })}
      onClick={() => props.column.toggleSorting(sorted === 'asc')}
    >
      {props.children}
      <Icon aria-hidden className="text-muted-foreground" />
    </Button>
  );
}
